
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12","r":"10","fill":"#A4D24F"}}),_c('path',{attrs:{"d":"M9.255 16V8.727h2.912c.535 0 .981.08 1.339.238.357.159.626.379.806.66.18.28.27.602.27.967 0 .284-.057.534-.17.749-.114.213-.27.388-.47.526-.196.134-.42.23-.674.287v.071a1.66 1.66 0 011.37.842c.152.258.228.566.228.923 0 .386-.096.73-.288 1.033-.19.301-.47.539-.841.714-.372.175-.83.263-1.375.263H9.255zm1.538-1.257h1.253c.429 0 .741-.082.938-.245a.82.82 0 00.294-.66.978.978 0 00-.145-.533.99.99 0 00-.416-.362 1.423 1.423 0 00-.635-.132h-1.29v1.932zm0-2.972h1.14c.21 0 .397-.037.56-.11a.933.933 0 00.391-.32.833.833 0 00.146-.494.798.798 0 00-.28-.635c-.185-.161-.448-.242-.789-.242h-1.168v1.8z","fill":"#000"}})])
          )
        }
      }
    